module.exports = __webpack_public_path__ + "img/3@2x.667957dc.png";